import React from "react";

// Language switcher rendered in the brand bar. Hidden when the tenant
// only supports one language (nothing to switch to).
export default function LanguagePicker({ langOptions, lang, setLang }) {
  if (langOptions.length <= 1) return null;
  return (
    <div className="lang-toggle" role="tablist" aria-label="Language">
      {langOptions.map((l) => (
        <button
          key={l.code}
          type="button"
          role="tab"
          aria-selected={lang === l.code}
          className={"lang-btn" + (lang === l.code ? " active" : "")}
          onClick={() => setLang(l.code)}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
